import { lazy, Suspense } from "react";
import { Button } from "../Button";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { useGoogleLogin } from "@react-oauth/google";
import TwitterLoginButton from "../TwitterLoginButton";
import TwitchLoginButton from "../TwitchLoginButton";
import { signInWithMetamask, signInWithGoogle } from "@redux/signIn/actions";
import { toggleSignUpModal } from "@redux/signUp/actions";
import { StorageService } from "@services/StorageService";
import { getWeb3Provider } from "@helpers/metamask";
import { removeEmptyKeys } from "@helpers/common";
import { downloadMetaMaskLink } from "@const/moralis";
import { localstorageKeys } from "@const/store";
import { useService } from "@/base/hooks/useService";
const IconMetamask = lazy(() =>
  import("@assets/ic-metamask.svg").then((module) => ({
    default: module.ReactComponent,
  })),
);
import { ReactComponent as IconGoogle } from "@assets/ic-google.svg";

import styles from "./index.module.scss";

const SocialButtons = ({ className }) => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector(({ signInReducer }) => signInReducer);

  const storageService = useService(StorageService);

  const referral = storageService.get(
    localstorageKeys.creatorReferral,
    {},
  ).newCreatorReferralCode;

  const trackingCode = storageService.get(localstorageKeys.trackingCode, "");

  const onGoogleSuccess = (codeResponse) => {
    const token = codeResponse.code;
    dispatch(
      signInWithGoogle(
        removeEmptyKeys({
          token,
          referral,
          trackingCode,
          link: window.location.href,
        }),
      ),
    );
    dispatch(toggleSignUpModal(false));
  };

  const login = useGoogleLogin({
    onSuccess: onGoogleSuccess,
    onFailure: console.log,
    flow: "auth-code",
  });

  const handleMetamaskAuth = async () => {
    const provider = await getWeb3Provider();

    if (!provider) {
      window.open(downloadMetaMaskLink, "_blank").focus();
      return;
    }
    dispatch(signInWithMetamask(removeEmptyKeys({ referral, trackingCode })));
    dispatch(toggleSignUpModal(false));
  };

  const disabled = isLoading;

  return (
    <div
      className={classNames(
        "d-flex align-items-center justify-content-center",
        styles.container,
        className,
      )}
    >
      <Button
        color="social"
        className={styles.iconButton}
        disabled={disabled}
        onClick={() => login()}
      >
        <IconGoogle />
      </Button>

      <TwitterLoginButton
        color="social"
        className={styles.iconButton}
        disabled={disabled}
      />
      <TwitchLoginButton
        color="social"
        className={styles.iconButton}
        disabled={disabled}
      />
      <Button
        color="social"
        className={styles.iconButton}
        onClick={handleMetamaskAuth}
        disabled={disabled}
      >
        <Suspense fallback="Loading...">
          <IconMetamask />
        </Suspense>
      </Button>
    </div>
  );
};

export default SocialButtons;
